document.addEventListener('DOMContentLoaded', () => {

  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('drawer-overlay');
  const body    = document.getElementById('drawer-body');
  const foot    = document.getElementById('drawer-foot');
  const total   = document.getElementById('drawer-total');
  const count   = document.getElementById('cart-count');

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    loadCart();
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.getElementById('cart-toggle')?.addEventListener('click', openDrawer);
  document.getElementById('cart-close')?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  function loadCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // update badge
        if (count) count.textContent = cart.item_count;

        if (cart.item_count === 0) {
          body.innerHTML = `<p style="text-align:center;padding:3rem 0;font-family:var(--font-head);font-size:0.8rem;letter-spacing:0.2em;color:var(--grey5);text-transform:uppercase;">Your cart is empty</p>`;
          foot.style.display = 'none';
          return;
        }

        body.innerHTML = cart.items.map(item => `
          <div class="op-ci">
            <img src="${item.image}" alt="${item.title}">
            <div>
              <p class="op-ci-title">${item.product_title}</p>
              <p class="op-ci-meta">${item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Qty ${item.quantity}</p>
              <p class="op-ci-meta" style="margin-top:0.25rem;color:var(--white)">${fmt(item.final_line_price)}</p>
            </div>
          </div>`).join('');

        total.textContent = fmt(cart.total_price);
        foot.style.display = 'block';
      });
  }

  // Add to cart buttons
  document.querySelectorAll('[data-variant]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.variant;
      const orig = btn.textContent;
      btn.textContent = 'ADDING…';
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });
        btn.textContent = 'ADDED ✓';
        setTimeout(openDrawer, 300);
      } catch {
        btn.textContent = 'ERROR';
      } finally {
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
      }
    });
  });

});
